import React from 'react'
import Navbar from '../Components/Navbar'
import Contact from '../Components/ContactComponents/Contact'
import Footer from '../Components/Footer'

function ContactPage() {
  return (
    <div>
        <Navbar/>
        <Contact/>
        <Footer/>
    </div>
  )
}

export default ContactPage